module.exports = require("@getvim/components-atoms-rounded-image");